import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"
import { readableColor } from "polished"

import { rhythm } from "@utils/typography"

const Wrapper = styled(Flex)`
  align-items: center;
  background-color: ${props => props.theme.colours.primary};
  color: ${props => readableColor(props.theme.colours.primary)};
  margin: ${rhythm(1)} auto;
  width: 100%;
`

const BarWrapper = styled.div`
  align-self: center;
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin-bottom: ${rhythm(1 / 2)};
  width: 100%;
  user-select: none;
`

const BarTime = styled.div`
  color: ${props => readableColor(props.theme.colours.primary)};
  font-weight: 600;
`

const BarProgress = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1;
  height: ${rhythm(1)};
  margin: 0 ${rhythm(1)};
`
const BarKnob = styled.span`
  background-color: ${props => props.theme.colours.secondary};
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  position: relative;
  height: ${rhythm(1.2)};
  width: ${rhythm(1.2)};
`

const Title = styled.h2`
  color: ${props => readableColor(props.theme.colours.primary)};
  margin-bottom: ${rhythm(1 / 2)};
`

const Control = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-right: ${rhythm(1 / 2)};
  & > svg path {
    fill: ${props => readableColor(props.theme.colours.primary)};
  }
  &:hover,
  &:focus {
    cursor: pointer;
    & > svg path {
      fill: ${props => props.theme.colours.secondary};
    }
  }
`

export { Control, BarWrapper, BarTime, BarProgress, BarKnob, Title, Wrapper }
